import axios from 'axios';
import Cookies from 'js-cookie';
import Config from '../Config.json';

const HEARTBEAT_INTERVAL = 5 * 60 * 1000; // 5 minutes
const STORAGE_KEY = 'expo.heartbeat.clientId';

let intervalId = null;

function getClientId() {
    let id = localStorage.getItem(STORAGE_KEY);
    if (!id) {
        id = crypto.randomUUID ? crypto.randomUUID() :
            'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        localStorage.setItem(STORAGE_KEY, id);
    }
    return id;
}

function getNarrativeFromURL() {
    var match = window.location.pathname.match(/\/narratives\/(\d+)/);
    return match ? parseInt(match[1], 10) : null;
}

function sendHeartbeat(narrativeId) {
    var token = Cookies.get('_expo_tokenid');
    var headers = { 'Content-Type': 'application/json' };
    if (token) headers['Authorization'] = 'Token ' + token;

    var nid = narrativeId || getNarrativeFromURL();

    var body = {
        client_id: getClientId(),
        client_type: 'cms',
        version: Config.buildMajor + '.' + Config.buildMinor + '.' + Config.buildRevision,
        status: nid ? 'editing' : 'idle',
        narrative_id: nid,
    };

    axios.post(Config.baseURL + '/api/core/heartbeat/', body, { headers: headers })
        .then(function() {
            console.log('Heartbeat sent');
        })
        .catch(function(err) {
            console.warn('Heartbeat failed', err);
        });
}

export function startHeartbeat() {
    if (intervalId) return;
    sendHeartbeat();
    intervalId = setInterval(function() { sendHeartbeat(); }, HEARTBEAT_INTERVAL);
}

export function sendHeartbeatWithNarrative(narrativeId) {
    sendHeartbeat(narrativeId);
}

export default { startHeartbeat, sendHeartbeatWithNarrative };
